export default "__VITE_ASSET__DbF8xspP__"